

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_SidebarSkeleton";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_SidebarSkeleton__root","lightSkeleton":"wds_1_182_0_SidebarSkeleton__lightSkeleton","skeletonItem":"wds_1_182_0_SidebarSkeleton__skeletonItem","separator":"wds_1_182_0_SidebarSkeleton__separator","container":"wds_1_182_0_SidebarSkeleton__container"};
export var keyframes = {"moveRight":"wds_1_182_0_SidebarSkeleton__moveRight"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




